var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.params.value)?_c('v-chip',{attrs:{"variant":_vm.badgeVariant,"small":"","color":_vm.badgeVariant}},[_c('v-icon',{attrs:{"x-small":""}},[_vm._v(_vm._s(_vm.icoClass))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }